import React, { useContext, useEffect, useState } from "react";

import { Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import {
  Box,
  ButtonStyled,
  FormButtonStyled,
  HeadingStyled,
  LabelStyled,
  SpanStyled,
} from "../../../../components/styled/Elements";
import { Cancel, CancelWhite } from "../../../../components/styled/AllImages";
import { LeadFormWrapper } from "./style";
import FormData from "form-data";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomRadioButton from "../../../../components/common/radioButtons/CustomRadio";
import ValidatedInput from "../../../../components/common/inputFields/ValidatedInput";
import { SelectionDropdown } from "../../../../components/styled/FormElements";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import FloatingPhoneInput from "../../../../components/common/inputFields/FloatingPhoneInput";
import VisitorApi from "../../../../services/api/visitorApi";
import { AuthContext } from "../../../../context/authContext";
import { requireAuthNavigate } from "../../../../utils";
import InquiryLoginRequired from "./InquiryLoginRequired";

const HalfCompLeadFormMob = ({ user }) => {
  const {
    t,
    i18n: { language, dir },
  } = useTranslation();
  const isRTL = dir() === "rtl";
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);

  const jsonInquiryData = localStorage.getItem("inquiry_form_data");
  const inquiryData = jsonInquiryData ? JSON.parse(jsonInquiryData) : {};

  const { username } = useParams();
  const [onChangeData, setOnChangeData] = useState({
    ...inquiryData,
    user_id: user?.id,
  });
  const [formValidationErrors, setFormValidationErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showBox, setShowBox] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [propertyType, setPropertyType] = useState("");
  const [bedroomActive, setBedroomActive] = useState(false);
  const [propertyState, setPropertyState] = useState({
    Apartment: false,
    Villa: false,
    Palace: false,
    Land: false,
    Building: false,
    Chalet: false,
    Farm: false,
    Duplex: false,
    Floor: false,
    "Rest House": false,
    terms_conditions: false,
  });
  const [propertyTypes, setPropertyTypes] = useState(null);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
  const [isResidential, setIsResidential] = useState(null);
  const [cityInputs, setCityInputs] = useState([{}]);

  const validationSchema = Yup.object().shape({
    inquiry_type: Yup.string().required("validate_inquiry_type"),
    property_category: Yup.string().required("validate_property_category"),
    property_type_id: Yup.array().min(1, "validate_property_type"),
    price_range: Yup.string().required("validate_price_range"),
    full_name: Yup.string().required("validate_full_name"),
    phone_number: Yup.string().required("Phone_requried"),
    cityInputs: Yup.array()
      .min(1, "validate_city_id")
      .of(
        Yup.object().shape({
          city_id: Yup.string().required("validate_city_id"),
          district_ids: Yup.array().notRequired(),
        })
      ),
    bedrooms: Yup.array().nullable().notRequired(),
    // district_ids: Yup.array()
    //   .min(1)
    //   .max(5, "district_max_validate")
    //   .notRequired(),
    // customer_type: Yup.string().required("validate_customer_type"),
  });

  const radioOptions = [
    { id: "1", label: t("Buy") },
    { id: "2", label: t("Rent") },
    { id: "3", label: t("Sale") },
  ];
  const categoryOptions = [
    { id: "1", label: t("Residential") },
    { id: "2", label: t("Commercial") },
  ];

  const handleSelectorChange = (e, id) => {
    let propertyName;
    if (id === "1") {
      setIsResidential(true);
      setSelectedPropertyTypes([]);
      propertyName = t("Residential");
      setOnChangeData((prevData) => ({ ...prevData, property_category: "1" }));
      getPropertyTypes(id);
    } else {
      setIsResidential(false);
      setSelectedPropertyTypes([]);
      propertyName = t("Commercial");
      setOnChangeData((prevData) => ({ ...prevData, property_category: "2" }));
      getPropertyTypes(id);
    }
    const newPropertyType = propertyName;

    const resetPropertyState = Object.keys(propertyState).reduce(
      (acc, property) => {
        acc[property] = false;
        return acc;
      },
      {}
    );
    setPropertyState(resetPropertyState);

    const resetBedroomState = Object.keys(bedroomState).reduce(
      (acc, bedroom) => {
        acc[bedroom] = false;
        return acc;
      },
      {}
    );
    setBedroomState(resetBedroomState);

    setPropertyType(newPropertyType);
    setBedroomActive(propertyState[newPropertyType]);
    setShowBox(false);
  };

  const handlePropertyChange = (propertyId, e) => {
    setPropertyState((prevState) => {
      const newPropertyState = {
        ...prevState,
        [propertyId]: !prevState[propertyId],
      };

      setOnChangeData((prevData) => {
        let updatedPropertyIds = prevData["property_type_id"] || [];

        if (newPropertyState[propertyId]) {
          updatedPropertyIds = [...updatedPropertyIds, propertyId];
        } else {
          updatedPropertyIds = updatedPropertyIds.filter(
            (id) => id !== propertyId
          );
        }

        return {
          ...prevData,
          property_type_id: updatedPropertyIds,
        };
      });

      const showroomId = 11;
      const officeSpaceId = 13;
      const insideMallId = "terms_conditions";

      const isShowroomOrOfficeSelected =
        newPropertyState[showroomId] || newPropertyState[officeSpaceId];

      if (isShowroomOrOfficeSelected) {
        newPropertyState[insideMallId] = true;
      } else {
        delete newPropertyState[insideMallId];
      }

      const isOtherPropertySelected = Object.keys(newPropertyState)
        .map(Number)
        .filter((prop) => prop !== showroomId && prop !== officeSpaceId)
        .some((prop) => newPropertyState[prop]);

      setShowBox(isShowroomOrOfficeSelected);
      setBedroomActive(isOtherPropertySelected);

      return newPropertyState;
    });
  };

  const [bedroomState, setBedroomState] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    "9+": false,
    Studio: false,
  });

  const handleBedroomChange = (bedroom) => {
    setBedroomState((prevState) => {
      const newBedroomState = {
        ...prevState,
        [bedroom]: !prevState[bedroom],
      };

      setOnChangeData((prevData) => {
        const updatedBedrooms = newBedroomState[bedroom]
          ? [...(prevData["bedrooms"] || []), bedroom]
          : (prevData["bedrooms"] || []).filter((b) => b !== bedroom);

        return { ...prevData, bedrooms: updatedBedrooms };
      });

      return newBedroomState;
    });
  };

  const handleAddDistricts = () => setShowModal(true);
  const [cityData, setCityData] = useState([]);
  const [selectedCity, setSelectedCity] = useState();
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [cityNameSelect, setCityNameSelect] = useState("");
  const [districts, setDistricts] = useState([]);
  const [selectedDistrictNames, setSelectedDistrictNames] = useState([]);

  const handleCityChange = (e, index) => {
    const city = e.target.value;
    const filteredCity = cityData?.find((item) => item?.value == city);

    setSelectedCity(city);
    getDistrictData(filteredCity?.id, city, index);
    setCityInputs((prev) => {
      const newInputs = [...prev];
      newInputs[index] = {
        ...newInputs[index],
        city_id: filteredCity?.id,
        district_ids: [],
        districts_list: [],
      };
      return newInputs;
    });
    setOnChangeData((prevData) => {
      const existingCityIds = prevData?.city_id || [];
      const newCityId = filteredCity?.id;

      if (!newCityId || existingCityIds.includes(newCityId)) {
        return prevData; // Do not update if id is missing or already exists
      }

      return {
        ...prevData,
        city_id: [...existingCityIds, newCityId],
      };
    });

    setShowModal(true);
    setSelectedDistricts([]);
    setSelectedDistrictNames([]);
  };
  const handleClose = () => {
    setShowModal(false);
  };
  const handleContinueClick = () => {
    setIsConfirm(true);
    setShowModal(false);
  };
  const getCityData = async () => {
    try {
      const body = await VisitorApi.getCitiesList();
      if (body?.data) {
        setCityData(
          body?.data?.map((city) => ({
            ...city,
            value: city?.id,
            label: language === "ar" ? city?.name_ar : city?.name_en,
          }))
        );
      }
    } catch (error) {}
  };

  const getPropertyTypes = async (type) => {
    try {
      const body = await VisitorApi.getPropertyTypes(type);
      if (body?.data) {
        // setPropertyTypes(
        //   response?.data?.data &&
        //     response?.data?.data?.map((item) => ({
        //       ...item,
        //       label: language === "en" ? item?.en_name : item?.ar_name,
        //       value: item?.id,
        //     }))
        // );
        const mappedProperties = body.data.map((property) => ({
          ...property,
          value: property.id,
          label: isRTL ? property.ar_name : property.en_name,
        }));

        const othersProperty = {
          id: 15,
          value: 15,
          label: t("others"),
          ar_name: t("others"),
          en_name: t("others"),
        };
        const sortOthersLast = (list) => {
          const others = list.filter((p) => Number(p.id) === 15);
          const rest = list.filter((p) => Number(p.id) !== 15);
          return [...rest, ...others];
        };
        const finalProperties = sortOthersLast(
          Number(type) === 1
            ? [...mappedProperties, othersProperty]
            : mappedProperties
        );

        setPropertyTypes(finalProperties);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (onChangeData?.property_category) {
      getPropertyTypes(onChangeData?.property_category);
    }
  }, [onChangeData?.property_category, language]);

  const getDistrictData = async (id, city, index) => {
    try {
      const districtBody = await VisitorApi.getDistricts(id);
      if (districtBody?.data) {
        setDistricts(
          districtBody?.data &&
            districtBody?.data?.map((item) => ({
              ...item,
              value: item?.id,
              label: isRTL ? item?.name_ar : item?.name_en,
            }))
        );
        setCityInputs((prev) => {
          let newInputs = [...prev];
          newInputs[index] = {
            ...newInputs[index],
            districts_list: districtBody?.data,
          };
          console.log(newInputs);

          return newInputs;
        });
      } else {
        const districtData = cityData?.filter(
          (city) => parseInt(city?.value) === parseInt(id)
        );
        setDistricts(districtData);
        setCityInputs((prev) => {
          let newInputs = [...prev];
          newInputs[index] = {
            ...newInputs[index],
            districts_list: districtData,
          };
          return newInputs;
        });
      }
    } catch (error) {}
  };
  useEffect(() => {
    getCityData();
  }, [isRTL]);
  useEffect(() => {
    const cityName = cityData.find(
      (city) => city.city_id == selectedCity
    )?.name_en;
    const cityNameInRTL = cityData.find(
      (city) => city.city_id == selectedCity
    )?.name_ar;
    const selectedCityName = isRTL ? cityNameInRTL : cityName;

    setCityNameSelect(selectedCityName || "");
  }, [selectedCity, cityData, isRTL]);

  const handleDistrictChange = (e, index) => {
    const districtId = parseInt(e.target.value);
    const district = districts.find((d) => d.id === districtId);

    if (!district) return;

    const singleName = isRTL ? district.name_ar : district.name_en;

    if (selectedDistricts.some((d) => d.id === districtId)) return;
    if (selectedDistricts.length >= 5) {
      alert("You can select up to 5 districts only.");
      return;
    }
    const updatedDistricts = [
      ...selectedDistricts,
      { id: districtId, name: singleName },
    ];

    setSelectedDistricts(updatedDistricts);

    setOnChangeData((prev) => ({
      ...prev,
      district_ids: updatedDistricts.map((d) => d.id),
    }));
    setCityInputs((prev) => {
      const newInputs = [...prev];
      newInputs[index] = {
        ...newInputs[index],
        district_ids: updatedDistricts.map((d) => d.id),
      };
      return newInputs;
    });
  };
  const handleRemoveCity = (removeIndex) => {
    const updatedInputs = cityInputs.filter(
      (_, index) => index !== removeIndex
    );
    setCityInputs(updatedInputs);
  };

  const validateFormData = async () => {
    try {
      await validationSchema.validate(onChangeData, { abortEarly: false });
      setFormValidationErrors({});
      return true;
    } catch (error) {
      const errors = {};
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
      setFormValidationErrors(errors);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !requireAuthNavigate(
        navigate,
        isAuthenticated,
        `${location.pathname}${location.search}`
      )
    ) {
      return;
    }
    const formData = new FormData();
    const isValidData = await validateFormData();
    if (!isValidData) return;

    Object.entries(onChangeData).forEach(([key, value]) => {
      if (key === "district_ids") return;
      if (key === "city_id") return;
      if (Array.isArray(value)) {
        if (key === "bedrooms")
          value.forEach((val) =>
            formData.append(
              `${key}[]`,
              val == "9+" ? 10 : val == "Studio" ? 11 : val
            )
          );
        // else if (key === "district_ids" && value && value?.length === 1)
        //   formData.delete(key);
        else value.forEach((val) => formData.append(`${key}[]`, val));
      } else {
        if (value !== undefined && value !== null && value !== "") {
          if (key == "id") {
            formData.append("inquiry_id", value);
          } else formData.append(key, value);
        }
      }
    });
    cityInputs.forEach((input) => {
      if (input.city_id) {
        formData.append("city_id[]", input.city_id);
      }
      if (Array.isArray(input.district_ids)) {
        input.district_ids.forEach((id) => {
          formData.append("district_ids[]", id);
        });
      }
    });

    try {
      setIsLoadingSubmit(true);
      const inquiryBody = await VisitorApi.createInquiry(formData);
      if (inquiryBody?.code === 200) {
        setOnChangeData({
          inquiry_type: "",
          property_category: "",
          full_name: "",
          phone_number: "",
          bedrooms: [],
          district_ids: [],
          city_id: [],
          property_type_id: [],
          user_id: user?.id,
        });
        localStorage.removeItem("inquiry_form_data");
        navigate(`/profile/${username}`, { replace: true });
        toast.success(t("inquiry_successful"));
      }
    } catch (error) {
    } finally {
      setIsLoadingSubmit(false);
    }
  };
  const [formErrors, setFormErrors] = useState({
    // propertyMain: '',
    // propertyCategory: '',
    // propertyType: '',
    // priceRange: '',
    // fullName: '',
    // phoneNumber: '',
    // cityId: '',
    // customerType: '',
    // Add more fields as needed
  });

  const onChangeHandler = (e) => {
    const { name, value } = e.target;

    if (value) {
      setOnChangeData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleInsideMallChange = (e) => {
    const isChecked = e.target.checked;

    setOnChangeData((prevData) => {
      if (isChecked) {
        return { ...prevData, inside_mall_only_bit: 1 };
      } else {
        const { inside_mall_only_bit, ...rest } = prevData;
        return rest;
      }
    });
  };

  const handlePriceChange = (price) => {
    setOnChangeData((prevData) => ({
      ...prevData,
      price_range: price,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOnChangeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRemoveDistrict = (districtId, index) => {
    const updatedDistricts = selectedDistricts.filter(
      (d) => d.id !== districtId
    );

    setSelectedDistricts(updatedDistricts);

    setCityInputs((prev) => {
      let newInputs = [...prev];
      newInputs[index] = {
        ...newInputs[index],
        district_ids: newInputs[index]?.district_ids?.filter(
          (dist) => dist != districtId
        ),
      };
      return newInputs;
    });

    setOnChangeData((prev) => ({
      ...prev,
      district_id: updatedDistricts.map((d) => d.id),
    }));
  };

  const handlePropertyTypeChange = (e) => {
    const propertyId = parseInt(e.target.value);
    const property = propertyTypes.find((p) => p.value === propertyId);

    if (!property) return;
    const newPropertyState = {
      ...propertyState,
      [propertyId]: !propertyState[propertyId],
    };

    const propertyName = property.label;

    if (selectedPropertyTypes?.some((p) => p.id === propertyId)) return;

    const updatedProperties = [
      ...selectedPropertyTypes,
      { id: propertyId, name: propertyName },
    ];

    setSelectedPropertyTypes(updatedProperties);

    setOnChangeData((prev) => ({
      ...prev,
      property_type_id: updatedProperties.map((p) => p.id),
    }));

    const showroomId = 11;
    const officeSpaceId = 13;
    const insideMallId = "terms_conditions";
    const farmId = 7;
    const landId = 4;
    const commercialLandId = 14;
    const buildingId = 12;
    const otherId = 15;

    const isShowroomOrOfficeSelected = newPropertyState[officeSpaceId];

    if (isShowroomOrOfficeSelected) {
      newPropertyState[insideMallId] = true;
    } else {
      delete newPropertyState[insideMallId];
    }

    const isOtherPropertySelected = Object.keys(newPropertyState)
      .map(Number)
      .filter(
        (prop) =>
          prop !== officeSpaceId &&
          prop !== farmId &&
          prop !== landId &&
          prop !== showroomId &&
          prop !== commercialLandId &&
          prop !== buildingId &&
          prop !== otherId
      )
      .some((prop) => newPropertyState[prop]);

    setBedroomActive(isOtherPropertySelected);
    setShowBox(isShowroomOrOfficeSelected);
    setPropertyState(newPropertyState);
    return newPropertyState;
  };

  const handleRemovePropertyType = (propertyId) => {
    const updatedProperties = selectedPropertyTypes.filter(
      (p) => p.id !== propertyId
    );

    setSelectedPropertyTypes(updatedProperties);

    const updatedPropertyState = {
      ...propertyState,
      [propertyId]: false,
    };

    const showroomId = 11;
    const officeSpaceId = 13;
    const insideMallId = "terms_conditions";
    const farmId = 7;
    const landId = 4;
    const commercialLandId = 14;
    const buildingId = 12;

    const isShowroomSelected = updatedPropertyState[officeSpaceId];
    if (isShowroomSelected) {
      updatedPropertyState[insideMallId] = true;
    } else {
      delete updatedPropertyState[insideMallId];
    }

    const isOtherPropertySelected =
      updatedProperties
        .map((p) => p.id)
        .filter(
          (prop) =>
            prop !== officeSpaceId &&
            prop !== farmId &&
            prop !== landId &&
            prop !== showroomId &&
            prop !== commercialLandId &&
            prop !== buildingId
        ).length > 0;

    setBedroomActive(isOtherPropertySelected);

    setPropertyState(updatedPropertyState);
    setOnChangeData((prev) => ({
      ...prev,
      property_type_id: updatedProperties.map((p) => p.id),
    }));
    setShowBox(isShowroomSelected);
  };

  const requiredFields = {
    inquiry_type: "string",
    property_category: "string",
    full_name: "string",
    phone_number: "string",
    // district_ids: "array",
    city_id: "array",
    property_type_id: "array",
  };

  const isAllFilled = Object.entries(requiredFields).every(([key, type]) => {
    const value = onChangeData?.[key];

    if (type === "string") {
      const result =
        (typeof value === "string" || typeof value === "number") &&
        String(value).trim() !== "";
      return result;
    }

    if (type === "array") {
      const result = Array.isArray(value) && value.length > 0;
      return result;
    }

    return false;
  });

  if (!isAuthenticated) {
    return <InquiryLoginRequired />;
  }

  return (
    <LeadFormWrapper>
      <form className="py-3" onSubmit={handleSubmit}>
        <Row>
          <Col lg={12} md={12}>
            <Box className="field-box border-bottom-line">
              <HeadingStyled className="label-heading">
                {t("property_purpose")}
              </HeadingStyled>
              <Box className="active-radio-container d-flex gap-2 flex-wrap">
                {radioOptions.map((option) => (
                  <Box className="w-full" key={option.id}>
                    <CustomRadioButton
                      name="inquiry_type"
                      label={t(option.label)}
                      value={option.id}
                      checked={option.id == onChangeData?.inquiry_type}
                      onChange={onChangeHandler}
                    />
                  </Box>
                ))}
              </Box>
              {formValidationErrors.inquiry_type && (
                <div className="error-message">
                  {t(formValidationErrors.inquiry_type)}
                </div>
              )}
            </Box>
          </Col>
          <Col lg={12} md={12}>
            <Box className="field-box border-bottom-line">
              <Box className="property-categories my-2">
                <HeadingStyled className="label-heading mb-2">
                  {t("Property_category")}{" "}
                </HeadingStyled>
                <Box className="active-radio-container d-flex gap-2 flex-wrap">
                  {categoryOptions.map((option) => (
                    <Box key={option.id}>
                      <CustomRadioButton
                        name="property_category"
                        label={t(option.label)}
                        value={option.id}
                        checked={option.id == onChangeData?.property_category}
                        onChange={(e) => handleSelectorChange(e, option.id)}
                      />
                    </Box>
                  ))}
                </Box>
                {formValidationErrors.property_category && (
                  <div className="error-message">
                    {t(formValidationErrors.property_category)}
                  </div>
                )}
                {onChangeData?.property_category == 1 && (
                  <>
                    <HeadingStyled className="label-heading mt-3">
                      {t("Property_Types")}{" "}
                    </HeadingStyled>
                    <Box className="mt-2">
                      <SelectionDropdown
                        name={"property_type_id"}
                        placeholder={t("choose_type")}
                        options={propertyTypes}
                        onChange={handlePropertyTypeChange}
                      />
                      {formValidationErrors.property_type_id && (
                        <div className="error-message">
                          {t(formValidationErrors.property_type_id)}
                        </div>
                      )}
                    </Box>
                  </>
                )}

                {onChangeData?.property_category == 2 && (
                  <>
                    <HeadingStyled className="label-heading mt-3">
                      {t("Property_Types")}{" "}
                    </HeadingStyled>
                    <Box className="mt-2">
                      <SelectionDropdown
                        name={"property_type_id"}
                        placeholder={t("choose_type")}
                        options={propertyTypes}
                        onChange={handlePropertyTypeChange}
                      />
                      {formValidationErrors.city_id && (
                        <div className="error-message">
                          {t(formValidationErrors.city_id)}
                        </div>
                      )}
                    </Box>
                  </>
                )}
                {propertyTypes &&
                  Array.isArray(propertyTypes) &&
                  selectedPropertyTypes?.length > 0 && (
                    <Box className="d-flex flex-wrap gap-2">
                      {selectedPropertyTypes.map((property) => (
                        <div
                          className="selected-box me-2 mt-2"
                          key={property.id}
                        >
                          <span>
                            {propertyTypes.find(
                              (prp) => prp.value == property.id
                            ).label || "N/A"}
                          </span>
                          <Cancel
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemovePropertyType(property.id);
                            }}
                            style={{ width: "9px", cursor: "pointer" }}
                          />
                        </div>
                      ))}
                    </Box>
                  )}

                {showBox && (
                  <Box className="check-box d-flex align-items-center gap-2 my-2">
                    <input
                      type="checkbox"
                      name="terms_conditions"
                      value={t("Inside_Mall_Only")}
                      id="terms-conditions"
                      onChange={handleInsideMallChange}
                    />
                    <LabelStyled
                      className="LabelStyled"
                      size="14px"
                      htmlFor="terms-conditions"
                    >
                      {t("Inside_Mall_Only")}
                    </LabelStyled>
                  </Box>
                )}
                {bedroomActive && (
                  <Box className="bedroom-container common-space">
                    <HeadingStyled size="14px" className="mb-2">
                      {t("Bedrooms")}
                    </HeadingStyled>
                    {/* <MultiSelectionDropdown
                      name={"bedrooms"}
                      placeholder={t("Bedrooms")}
                      options={Object.keys(bedroomState).map((bedroom) => ({
                        label: t(bedroom),
                        value: t(bedroom),
                      }))}
                      value={onChangeData?.bedrooms}
                      onChange={(selected) => handleBedroomChange(selected)}
                    /> */}
                    <SelectionDropdown
                      name={"bedrooms"}
                      placeholder={t("Bedrooms")}
                      options={Object.keys(bedroomState).map((bedroom) => ({
                        label: t(bedroom),
                        value: bedroom,
                      }))}
                      onChange={(e) => handleBedroomChange(e.target.value)}
                    />
                    {/* <Box className="active-check-container d-flex gap-2">
                      {Object.keys(bedroomState).map((bedroom) => (
                        <Box key={bedroom}>
                          <CustomCheckbox
                            id={bedroom}
                            label={t(bedroom)}
                            value={t(bedroom)}
                            name="bedrooms"
                            checked={bedroomState[bedroom]}
                            onChange={() => handleBedroomChange(bedroom)}
                          />
                        </Box>
                      ))}
                    </Box> */}
                    {formValidationErrors.bedrooms && (
                      <div className="error-message">
                        {t(formValidationErrors.bedrooms)}
                      </div>
                    )}
                  </Box>
                )}
                {Object.entries(bedroomState).length > 0 && (
                  <Box className="d-flex flex-wrap gap-2">
                    {Object.entries(bedroomState)
                      .filter(([_, value]) => value) // Keep only entries where value is true
                      .map(([key], index) => (
                        <div className="selected-box me-2 mt-2" key={index}>
                          <span>{t(key)}</span>
                          <Cancel
                            onClick={(e) => {
                              e.stopPropagation();
                              setBedroomState((prev) => ({
                                ...prev,
                                [key]: false,
                              }));
                              setOnChangeData((prevData) => ({
                                ...prevData,
                                bedrooms: onChangeData?.bedrooms?.filter(
                                  (bedroom) => bedroom != key
                                ),
                              }));
                            }}
                            style={{ width: "9px", cursor: "pointer" }}
                          />
                        </div>
                      ))}
                  </Box>
                )}
              </Box>
              <Box className="price-range my-2">
                <HeadingStyled className="label-heading mb-2">
                  {t("Price_Range")}
                </HeadingStyled>
                <Box className="active-radio-container d-flex gap-2 flex-wrap">
                  {[
                    { id: "More_Then_2M", value: 1 },
                    { id: "1M_To_2M", value: 2 },
                    { id: "500K_To_1M", value: 3 },
                    { id: "Less_Then_500k", value: 4 },
                  ].map((range) => (
                    <div className="w-full" key={range.id}>
                      <CustomRadioButton
                        name="price_range"
                        label={t(range.id)}
                        value={t(range.value)}
                        checked={range.value == onChangeData?.price_range}
                        onChange={() => handlePriceChange(t(range.value))}
                        // checked={option.label === propertyType}
                        // onChange={(e) => handleSelectorChange(e, option.id)}
                      />
                    </div>
                  ))}
                </Box>
                {formValidationErrors.price_range && (
                  <div className="error-message mt-2">
                    {t(formValidationErrors.price_range)}
                  </div>
                )}
              </Box>
            </Box>
          </Col>

          <Col lg={6} md={12}>
            <Box className="field-box">
              <HeadingStyled className="label-heading">
                {t("Full_Name")}{" "}
              </HeadingStyled>
              <ValidatedInput
                name="full_name"
                // label={"Full_Name"}
                type="input"
                fieldType="text"
                placeholder={t("Full_Name_place")}
                className={"w-100 mb-0 combined flex-wrap p-0"}
                value={onChangeData?.full_name || ""}
                onChange={handleInputChange}
              />
              {formValidationErrors.full_name && (
                <div className="error-message">
                  {t(formValidationErrors.full_name)}
                </div>
              )}
            </Box>
          </Col>
          <Col lg={6} md={12}>
            <Box className="field-box">
              <HeadingStyled className="label-heading">
                {" "}
                {t("Phone_Number")}{" "}
              </HeadingStyled>
              <FloatingPhoneInput
                name="phone_number"
                // label={"Full_Name"}
                placeholder={t("Phone_Number_place")}
                className={"w-100 my-2 combined flex-wrap p-0"}
                value={onChangeData?.phone_number || ""}
                onChange={handleInputChange}
              />
              {/* <input
                className="input-field"
                type="number"
                name="phone_number"
                placeholder={t("Phone_Number_place")}
              /> */}
              {formValidationErrors.phone_number && (
                <div className="error-message">
                  {t(formValidationErrors.phone_number)}
                </div>
              )}
            </Box>
          </Col>
          {cityInputs.map((_, index) => (
            <Col lg={12} md={12}>
              <Box
                className={`field-box border-bottom-line ${
                  index > 0 && "border-top mt-4"
                }`}
              >
                <Box className="d-flex justify-content-between align-items-center">
                  <HeadingStyled className="label-heading">
                    {t("City")}
                  </HeadingStyled>
                  {index > 0 && (
                    <ButtonStyled
                      icon={CancelWhite}
                      type="button"
                      label={t("remove")}
                      iconWidth="14px"
                      bg={"var(--themeColorSecondary)"}
                      onClick={() => handleRemoveCity(index)}
                    />
                  )}
                </Box>

                <SelectionDropdown
                  name={`city_id_${index}`}
                  placeholder={t("City")}
                  options={cityData}
                  // value={selectedCity}
                  onChange={(e) => handleCityChange(e, index)}
                />

                {formValidationErrors?.city_id && (
                  <div className="error-message">
                    {t(formValidationErrors.city_id)}
                  </div>
                )}
                {cityInputs[index]?.city_id && (
                  <>
                    <SelectionDropdown
                      name={"districts_id[]"}
                      placeholder={t("District")}
                      options={
                        cityInputs[index]?.districts_list?.map((dist) => ({
                          value: dist?.id,
                          label:
                            language === "en" ? dist?.name_en : dist?.name_ar,
                        })) || []
                      }
                      // value={selectedCity}
                      onChange={(e) => handleDistrictChange(e, index)}
                    />
                    {formValidationErrors.district_ids && (
                      <div className="error-message">
                        {t(formValidationErrors.district_ids)}
                      </div>
                    )}
                  </>
                )}

                {cityInputs[index]?.city_id && (
                  <Box className="field-box">
                    <SpanStyled size="12px" className="label-heading">
                      {t("District")}
                    </SpanStyled>
                    <Box className="d-flex align-items-center flex-wrap gap-2">
                      <Box className="selected-data-show d-flex flex-wrap align-items-center gap-2">
                        {cityInputs[index]?.districts_list
                          ?.filter((dist) =>
                            cityInputs[index]?.district_ids?.includes(dist?.id)
                          )
                          ?.map((district) => (
                            <div className="selected-box" key={district.id}>
                              <span>
                                {language === "en"
                                  ? district?.name_en
                                  : district.name_ar}
                              </span>
                              <Cancel
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveDistrict(district.id, index);
                                }}
                                style={{ width: "9px", cursor: "pointer" }}
                              />
                            </div>
                          ))}
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
              {cityInputs[0]?.city_id && (
                <Box className="d-flex align-items-center justify-content-end mt-3">
                  <ButtonStyled
                    type="button"
                    label={t("add_city")}
                    onClick={() => setCityInputs([...cityInputs, {}])}
                  />
                </Box>
              )}
            </Col>
          ))}

          <Col lg={12} md={12}>
            <Box className="field-box border-bottom-line">
              <HeadingStyled className="label-heading">
                {t("Customer_type")}
              </HeadingStyled>
              <Box className="active-radio-container d-flex gap-2 flex-wrap">
                {[
                  { value: 1, id: "Property_seeker" },
                  { value: 2, id: "Broker" },
                  { value: 3, id: "Investor" },
                  { value: 4, id: "developer" },
                  { value: 5, id: "service_provider" },
                  { value: 6, id: "others" },
                ]?.map((type) => (
                  <div className="w-full" key={type.id}>
                    <CustomRadioButton
                      name="customer_type"
                      label={t(type.id)}
                      value={t(type.value)}
                      onChange={handleInputChange}
                      checked={type.value == onChangeData?.customer_type}
                      // onChange={(e) => handleSelectorChange(e, option.id)}
                    />
                  </div>
                ))}
              </Box>
              {/* {formErrors.customerType && <div className="error-message">{formErrors.customerType}</div>} */}
            </Box>
          </Col>
          <Col style={{ width: "100%" }} lg={6} md={12}>
            <Box className="field-box">
              <HeadingStyled className="label-heading">
                {t("message")}{" "}
              </HeadingStyled>
              <ValidatedInput
                name="message"
                // label={"Full_Name"}
                type="textarea"
                fieldType="text"
                placeholder={t("message")}
                className={"w-100 mb-0 combined flex-wrap p-0"}
                value={onChangeData?.message || ""}
                onChange={handleInputChange}
              />
              {formValidationErrors.message && (
                <div className="error-message">
                  {t(formValidationErrors.message)}
                </div>
              )}
            </Box>
          </Col>
          <Box className="d-flex align-items-center gap-2 justify-content-end mt-3">
            <FormButtonStyled
              label={t("Cancel")}
              bg="transparent"
              shadow="false"
              color="var(--lightGrey)"
              onClick={() => navigate(`/profile/${username}`)}
              className="w-100"
              clName="w-100"
              border="var(--border)"
            />
            <ButtonStyled
              disabled={!isAllFilled || isLoadingSubmit}
              isLoading={isLoadingSubmit}
              label={t("submit")}
              className="w-100"
              clName="w-100"
              // bg="var(--themeColorSecondary)"
              type="submit"
            />
            {/* <p className='loading-btn'><span className='spinner'></span></p> */}
          </Box>
        </Row>
      </form>
    </LeadFormWrapper>
  );
};

export default HalfCompLeadFormMob;
